import React from 'react';

export const A = (circle: string, path: string): JSX.Element => {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22.5" cy="22.5" r="22.5" fill={circle} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.351 30.64c-.37.32-.795.48-1.275.48-.32 0-.62-.085-.9-.255-.28-.17-.5-.435-.66-.795l-1.8-4.02h-10.56l-1.8 4.02c-.16.36-.38.625-.66.795-.28.17-.59.255-.93.255-.46 0-.88-.16-1.26-.48-.38-.32-.57-.71-.57-1.17 0-.26.06-.52.18-.78l8.28-17.79c.18-.4.455-.705.825-.915.37-.21.765-.315 1.185-.315.42 0 .815.105 1.185.315.37.21.645.515.825.915l8.31 17.79c.12.26.18.52.18.78 0 .46-.185.85-.555 1.17zm-9.915-16.5-3.96 8.91h7.92l-3.96-8.91z"
        fill={path}
      />
    </svg>
  );
};

export const B = (circle: string, path: string): JSX.Element => {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22.5" cy="22.5" r="22.5" fill={circle} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.041 32c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065-1.25-.97-2.975-1.455-5.175-1.455h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89v-5.91h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zM18.221 29h5.4c1.4 0 2.42-.25 3.06-.75.64-.5.96-1.28.96-2.34 0-1.06-.325-1.85-.975-2.37-.65-.52-1.665-.78-3.045-.78h-5.4V29z"
        fill={path}
      />
    </svg>
  );
};
